import React, { Component, PropTypes } from "react";
// import ReactHighcharts from 'react-highcharts';

import config from "./ChartHeatMapConfig";
import { NitroLoading, NitroContentNotAvailable, NitroIcon } from "nitro-components";

import Highcharts from "highcharts";
import treemap from "highcharts/modules/treemap";
import exporting from "highcharts/modules/exporting";
import RHC from "react-highcharts";

import { merge } from "lodash";

import styled from "styled-components";

import heatMapTheme from "../highcharts-themes/heatMapTheme";

import { getColour } from "../highcharts-themes/helper";

// TODO: Get real icons
// import { icon } from "../fleet-composition-icons/icon";
const icon = () => '';

let chartInstance;
exporting(Highcharts);
treemap(Highcharts);

const ReactHighcharts = RHC.withHighcharts(Highcharts);

// Arbitrary constants purely based on observations
const DISPLAY_ICON_VALUE = 0.10;
const DISPLAY_LABEL_VALUE = 0.028;

const ChartFontWrapper = styled.div`
  font-size: 16px;
  font-size: calc(10px + 1.5vw);

  @media (min-width: 1000px) {
    font-size: 24px;
  }
`;

class ChartHeatMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chart: null,
      total: 0
    };
  }

  componentDidMount() {
    if (this.refs.chart) chartInstance = this.refs.chart.getChart();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      chartInstance = this.refs.chart.getChart();
      chartInstance.reflow = () => {};
    }
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data;
  }

  export = option => {
    const { data } = this.props;
     const chart = this.refs.chart;
    // console.log(chart.getChart().getSVG());
   // this.props.exportDocument(this.refs.chart.getChart().getSVG(), this.getChartOptions(true));
   //Using highcharts export api since HTML is not suppported by server api for export
    this.refs.chart.getChart().exportChart(option, this.getChartOptions(true));
  };

  afterRender = chart => {
  };

  getChartOptions = (isExport) => {
    const { data, plotOptions, insideDrawer } = this.props;
    const total = data.series.reduce((t, o) => t += o.value, 0);
    const seriesOptions = plotOptions ? plotOptions.series : {};
    return Object.assign({}, config, {
      title: "",
      series: [
        Object.assign(seriesOptions, {
          type: "treemap",
          layoutAlgorithm: "squarified",
          data: data.series,
        levels: [{
            level: 1,
            layoutAlgorithm: 'squarified',
            dataLabels: {
              dataLabels: "center",
              allowOverlap: false,
              enabled: true,
              color: "#fff",
              style: {
                fontSize: 'inherit',
                textShadow: false
              },
            crop: true,
            useHTML: true,
            formatter: function() {
              const valueScale = this.point.value / total;
              const displayIcon = valueScale > DISPLAY_ICON_VALUE;
              const displayLabel = valueScale > DISPLAY_LABEL_VALUE;
              const image = this.point.Icon ? require(`../../../assets/icons/fleetComposition/${this.point.Icon}.svg`) : null;
              const imageWidth = image ? "100%" : "0px";

            if (this.point.series.chart.options.chart.forExport) {
                const fontSize = 16 + 50 * valueScale;
                const labelFontSize = 7 + 5 * valueScale;
                const iconSize = 16 + 30 * valueScale;

                return displayLabel ? `
                  <span class="cutom-label" style='text-align: center; pointer-events: none;'>
                    ${displayIcon ? `
                      <div style="width:${iconSize}px; margin: 0 auto;">
                       <img src=${image} alt="" width="30px"/>
                      </div>
                    ` : ''}
                    <div style="text-align: center; font-size:${fontSize}px;">
                      ${this.point.value}
                    </div>
                    <div style="text-align: center; font-size:${labelFontSize}px;">
                      ${this.point.name}
                    </div>
                  </span>
                ` : '';
              }

                if(!this.point.series.chart.options.chart.forExport) {
                const drawerScale = insideDrawer ? 0.35 : 1;
                const fontSize = 1 + 5 * valueScale * drawerScale;
                const labelFontSize = 0.5 + 0.35 * valueScale * drawerScale;
                const iconSize = 1 + 3 * valueScale * drawerScale;
               
                return displayLabel ? `
                  <div style='text-align: center; cursor: pointer;'>
                    ${displayIcon ? `
                      <div style="width:${iconSize}em; margin: 0 auto">
                        <img src=${image} alt="" width=${imageWidth} height="100%"/>
                      </div>
                    ` : ''}
                    <div style="font-size:${fontSize}em">
                      ${this.point.value}
                    </div>
                    <div style="font-size:${labelFontSize}em">
                      ${this.point.name}
                    </div>
                  </div>
                ` : '';
                } 
            }
            }
        }]
        })
      ],
      plotOptions: {
        series: {
          colorByPoint: true
        }
      },
       exporting: {
          allowHTML: true,
          enabled: false
      }
    });
  }

  render() {
    const { data } = this.props;

    if (data) {
      const chartConfig = this.getChartOptions(false);

    // Apply the theme
      Highcharts.theme = heatMapTheme;
      const newTheme = {
        ...heatMapTheme,
        colors: getColour(data.series.length, 'heatmap')
      };
      Highcharts.setOptions(newTheme);
      if(!data.series.length)
       return <NitroContentNotAvailable />
      

      return (
        <ChartFontWrapper>
          <ReactHighcharts
            ref="chart"
            config={chartConfig}
            callback={this.afterRender}
          />
        </ChartFontWrapper>
      );
    } else {
      return <NitroLoading center thickness={2} size={24} />;
    }
  }
}

ChartHeatMap.propTypes = {
  exportOptions: PropTypes.object,
  plotOptions: PropTypes.object,
  disableDataPoints: PropTypes.bool,
  insideDrawer: PropTypes.bool,
  data: PropTypes.object.isRequired,
  error: PropTypes.bool, // TODO .isRequired
  exportDocument: PropTypes.func
};


export default ChartHeatMap;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartHeatMap.js